export default __webpack_public_path__ + "static/media/tea-ginger.217309ae.png";